import { Helmet } from "react-helmet";
export const SplitPDFHelmet = () => {
    return (
        <Helmet>
            <title>Split PDF Online - Custom Range, Even/Odd, Equal Parts & Groups | Utilix Pro</title>
            <meta name="description" content="Split PDF files into custom ranges, even/odd pages, equal parts, or multiple groups. Extract specific pages, divide PDFs into sections, and manage document splitting easily with Utilix Pro." />
            <meta name="keywords" content="split PDF, extract PDF pages, split PDF by range, even pages, odd pages, split PDF into equal parts, custom split PDF, split PDF into multiple parts, advanced PDF splitter" />
            <meta property="og:title" content="Split PDF Online - Custom Range, Even/Odd, Equal Parts & Groups | Utilix Pro" />
            <meta property="og:description" content="Utilix Pro offers an advanced PDF splitter to divide PDFs by custom range, even/odd pages, equal sections, and multiple groups. Try it now!" />
            <meta property="og:url" content={window.location.origin + '/split-pdf'} />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={window.location.origin + '/assets/split-pdf-preview.jpg'} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Split PDF Online - Advanced PDF Splitter | Utilix Pro" />
            <meta name="twitter:description" content="Easily split PDFs by custom range, even/odd pages, equal parts, or multiple groups with Utilix Pro’s advanced PDF splitter." />
            <meta name="twitter:image" content={window.location.origin + '/assets/split-pdf-preview.jpg'} />
            <link rel="canonical" href={window.location.origin + '/split-pdf'} />
        </Helmet>
    );
};

export const RotatePDFHelmet = () => {
    return (
        <Helmet>
            <title>Rotate PDF Pages Online - Free PDF Rotator | Utilix Pro</title>
            <meta name="description" content="Rotate PDF pages online for free. Adjust the orientation of your PDF pages with Utilix Pro’s easy-to-use tool." />
            <meta name="keywords" content="rotate PDF, PDF rotator, change PDF orientation, flip PDF pages, online PDF rotation" />
            <meta property="og:title" content="Rotate PDF Pages Online - Utilix Pro" />
            <meta property="og:description" content="Quickly rotate and adjust the orientation of your PDF pages online with Utilix Pro." />
            <meta property="og:url" content={window.location.origin + '/rotate-pdf'} />
            <link rel="canonical" href={window.location.origin + '/rotate-pdf'} />
        </Helmet>
    );
};

export const ReorderPDFHelmet = () => {
    return (
        <Helmet>
            <title>Reorder PDF Pages Online - Arrange PDF Order | Utilix Pro</title>
            <meta name="description" content="Reorder pages in a PDF file online with Utilix Pro. Easily change the sequence of PDF pages for free." />
            <meta name="keywords" content="reorder PDF, rearrange PDF pages, change PDF order, PDF page organizer, PDF editor" />
            <meta property="og:title" content="Reorder PDF Pages Online - Utilix Pro" />
            <meta property="og:description" content="Easily rearrange and reorder pages in your PDF file with Utilix Pro’s online PDF editor." />
            <meta property="og:url" content={window.location.origin + '/reorder-pdf'} />
            <link rel="canonical" href={window.location.origin + '/reorder-pdf'} />
        </Helmet>
    );
};

export const WatermarkPDFHelmet = () => {
    return (
        <Helmet>
            <title>Add Custom Watermark to PDF - Text & Image Watermarks | Utilix Pro</title>
            <meta name="description" content="Easily add dynamic watermarks to your PDFs with Utilix Pro. Customize watermark text, color, rotation, font size, or upload an image as a watermark and apply it to your PDF pages." />
            <meta name="keywords" content="add watermark to PDF, custom watermark PDF, watermark PDF online, text watermark, image watermark, rotate watermark, PDF watermark tool, insert watermark in PDF, protect PDF documents" />
            <meta property="og:title" content="Add Custom Watermark to PDF - Text & Image | Utilix Pro" />
            <meta property="og:description" content="Personalize your PDFs with custom text or image watermarks. Adjust font size, rotation, transparency, and color, or upload an image watermark with Utilix Pro." />
            <meta property="og:url" content={window.location.origin + '/watermark-pdf'} />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={window.location.origin + '/assets/watermark-pdf-preview.jpg'} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Add Custom Watermark to PDF - Text & Image | Utilix Pro" />
            <meta name="twitter:description" content="Create professional PDF watermarks with text or images. Customize font, rotation, transparency, and color, or upload your own watermark image." />
            <meta name="twitter:image" content={window.location.origin + '/assets/watermark-pdf-preview.jpg'} />
            <link rel="canonical" href={window.location.origin + '/watermark-pdf'} />
        </Helmet>
    );
};

export const EditPDFMetadataHelmet = () => {
    return (
        <Helmet>
            <title>Edit PDF Metadata Online - Modify PDF Info | Utilix Pro</title>
            <meta name="description" content="Modify your PDF metadata online with Utilix Pro. Change title, author, subject, and keywords in your PDF documents." />
            <meta name="keywords" content="edit PDF metadata, change PDF title, modify PDF properties, PDF metadata editor" />
            <meta property="og:title" content="Edit PDF Metadata Online - Utilix Pro" />
            <meta property="og:description" content="Easily edit and update your PDF metadata online with Utilix Pro. Modify document title, author, and more." />
            <meta property="og:url" content={window.location.origin + '/edit-pdf-metadata'} />
            <link rel="canonical" href={window.location.origin + '/edit-pdf-metadata'} />
        </Helmet>
    );
};

export const CustomSplitPDFHelmet = () => {
    return (
        <Helmet>
            <title>Advanced PDF Split Tool - Custom Split PDF Online | Utilix Pro</title>
            <meta name="description" content="Split PDF files with advanced options. Use Utilix Pro’s custom split tool to extract pages, divide PDFs, and create new files." />
            <meta name="keywords" content="custom split PDF, advanced PDF splitter, extract PDF pages, divide PDFs, split PDF tool" />
            <meta property="og:title" content="Advanced PDF Split Tool - Utilix Pro" />
            <meta property="og:description" content="Utilix Pro lets you split PDF files with advanced custom options. Extract specific pages or divide PDFs effortlessly." />
            <meta property="og:url" content={window.location.origin + '/custom-split-pdf'} />
            <link rel="canonical" href={window.location.origin + '/custom-split-pdf'} />
        </Helmet>
    );
};

export const BatchPDFProcessingHelmet = () => {
    return (
        <Helmet>
            <title>Batch PDF Processing Online - Edit Multiple PDFs | Utilix Pro</title>
            <meta name="description" content="Process multiple PDF files at once with Utilix Pro. Merge, split, rotate, and edit PDFs in bulk online." />
            <meta name="keywords" content="batch PDF processing, edit multiple PDFs, bulk PDF editor, merge multiple PDFs, split multiple PDFs, PDF batch tool" />
            <meta property="og:title" content="Batch PDF Processing Online - Utilix Pro" />
            <meta property="og:description" content="Save time by processing multiple PDFs at once with Utilix Pro’s batch editing tools." />
            <meta property="og:url" content={window.location.origin + '/batch-pdf-processing'} />
            <link rel="canonical" href={window.location.origin + '/batch-pdf-processing'} />
        </Helmet>
    );
};


export const ImageToPDFHelmet = () => {
    return (
        <Helmet>
            <title>Image to PDF - Convert & Arrange Images to PDF Online | Utilix Pro</title>
            <meta name="description" content="Easily convert multiple images to PDF online. Upload, arrange images in any order, and create high-quality PDFs with Utilix Pro's free image-to-PDF converter." />
            <meta name="keywords" content="image to PDF, convert images to PDF, JPG to PDF, PNG to PDF, online image to PDF converter, arrange images in PDF, free image to PDF tool, merge images into PDF" />
            <meta property="og:title" content="Convert Images to PDF Online - Free & Easy | Utilix Pro" />
            <meta property="og:description" content="Utilix Pro offers an easy-to-use image-to-PDF converter. Upload, rearrange images, and convert them into a high-quality PDF instantly!" />
            <meta property="og:url" content={window.location.origin + '/image-to-pdf'} />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={window.location.origin + '/assets/image-to-pdf-preview.jpg'} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Image to PDF - Convert & Arrange Images Online | Utilix Pro" />
            <meta name="twitter:description" content="Upload multiple images, arrange them in your desired order, and convert them into a PDF easily with Utilix Pro's image-to-PDF converter." />
            <meta name="twitter:image" content={window.location.origin + '/assets/image-to-pdf-preview.jpg'} />
            <link rel="canonical" href={window.location.origin + '/image-to-pdf'} />
        </Helmet>
    );
};


export const MergePDFHelmet = () => {
    return (
        <Helmet>
            <title>Merge PDF Files Online - Combine & Arrange PDFs | Utilix Pro</title>
            <meta name="description" content="Easily merge multiple PDF files online with Utilix Pro. Upload, arrange in any order, and combine them into a single PDF effortlessly." />
            <meta name="keywords" content="merge PDF, combine PDFs, PDF merger, reorder PDF pages, join PDFs online, merge PDF tool, arrange PDF files" />
            <meta property="og:title" content="Merge PDF Files Online - Combine & Reorder | Utilix Pro" />
            <meta property="og:description" content="Upload multiple PDFs, arrange them in your desired order, and merge them into one document with Utilix Pro’s free online PDF merger." />
            <meta property="og:url" content={window.location.origin + '/merge-pdf'} />
            <link rel="canonical" href={window.location.origin + '/merge-pdf'} />
        </Helmet>
    );
};